import type { ReactNode } from "react";
import { DashedCard } from "../ui/DashedCard";

type PricingTierProps = {
  label: string;
  price: ReactNode;
  priceSuffix?: string;
  description: ReactNode;
  features: string[];
  cta: ReactNode;
  accent?: boolean;
  priceClassName?: string;
};

export function PricingTier({
  label,
  price,
  priceSuffix,
  description,
  features,
  cta,
  accent,
  priceClassName = "text-7xl",
}: PricingTierProps) {
  return (
    <DashedCard accent={accent} className="p-9" hover={false}>
      <div className={`font-mono text-xs tracking-[0.16em] ${accent ? "text-accent" : "text-td-1"}`}>
        {label}
      </div>
      <div className="flex items-baseline gap-2 mt-4">
        <span className={`font-display italic font-extrabold leading-none text-td-1 ${priceClassName}`}>
          {price}
        </span>
        {priceSuffix && (
          <span className="text-[13px] text-td-2">{priceSuffix}</span>
        )}
      </div>
      <p className="mt-2 text-sm italic text-td-2">{description}</p>
      <ul className="mt-7 flex flex-col gap-2.5">
        {features.map((f) => (
          <li key={f} className="flex gap-3 items-start text-sm text-td-2">
            <span className="text-accent font-mono">✓</span>
            <span>{f}</span>
          </li>
        ))}
      </ul>
      <div className="mt-8">{cta}</div>
    </DashedCard>
  );
}
